import React, { useEffect, useRef, useState } from "react"
import { Button, Image } from "semantic-ui-react"
import ReactSVG from "react-svg"
import ServiceRow from "./CartServiceRow"
import MaintenanceScheduleServices from "./MaintenanceScheduleServicesSection"
import { Link } from "react-router-dom"
import { navigationPaths, routerPaths } from "../../../v1/constants/paths"
import NoAddedService from "../Services/NoAddedServices"
import DefaultShopLogo from "../../../images/default_shop_logo.svg"
import { DEFAULT_IMG_URL } from "../../../v1/constants/confirmDetails"
import { fetchVehicleName } from "../../../v1/helpers/vehicleHelpers"
import { OPEN_EXPANDED_MAP_VIEW } from "../../../v1/constants/shops"
import RocketSvg from "../../../images/rocket.svg"
import { UBER_PARENT } from "../../../v1/constants/affiliations"
import { validServicesForValvoline } from "../../../v1/actions/user"
import SplitClient, { VALVOLINE_COMPANY_ID } from "../../../v1/components/Config/SplitClient"
import { OIL_CHANGE } from "../../../v1/actions/services"
import placeholderCarImg from "../../../images/placeholder_car.svg"
import InfoLogo from "../../../images/info-strock.svg"

const ServiceSection = ({
  cart,
  cartQuantity,
  t,
  updateCart,
  user,
  closeSidebar,
  shop,
  isCart = true,
  activeVehicle,
  isFirstOrder,
  close,
  onScrollChange,
  isFooterExpanded,
  showModifyAppointment,
  isMiniCart
}) => {
  const scrollableRef = useRef(null)
  const [valvolineCompanyId, setValvolineCompanyId] = useState(null)

  const handleScroll = () => {
    if (scrollableRef.current) {
      const isScrolled = scrollableRef.current.scrollTop > 0
      if (isScrolled && isFooterExpanded) {
        onScrollChange(scrollableRef.current.scrollTop)
      }
    }
  }

  const openExpandedMapView = async () => {
    const data = {
      show: true,
      hideCart: false
    }
    const events = new CustomEvent(OPEN_EXPANDED_MAP_VIEW, { detail: data })
    document.dispatchEvent(events)
    await close()
  }

  useEffect(() => {
    if (isFooterExpanded) {
      scrollableRef.current && scrollableRef.current.addEventListener(SCROLL, handleScroll)
    }
    return () => {
      scrollableRef.current && scrollableRef.current.removeEventListener(SCROLL, handleScroll)
    }
  }, [isFooterExpanded])

  const shouldShowFooter =
    (shop && !shop.cdk_dealer && (shop || (cart.total_savings && cart.total_savings > 0))) || false

  useEffect(() => {
    async function getValvolineId() {
      const treatment = await SplitClient.getTreatment(VALVOLINE_COMPANY_ID, user)
      setValvolineCompanyId(treatment[VALVOLINE_COMPANY_ID])
    }
    getValvolineId()
  }, [])

  const showValvolineServiceMessage = () => {
    const servicesRequested = cart.order_services.filter(
      (service) => service.reference_id === OIL_CHANGE
    )
    return (
      user.affiliation &&
      user.affiliation.parent_name === UBER_PARENT &&
      servicesRequested.length === 1 &&
      shop &&
      shop.company_id === parseInt(valvolineCompanyId)
    )
  }

  return (
    <div className="side-panel-service-section-parent">
      {cart && cart.order_services.length > 0 ? (
        <div className="side-panel_services-section" ref={scrollableRef}>
          <div className="side-panel_services_container">
            <div className="side-panel-services-shop-section">
              <div className="shop-name-section">
                <div className="shop-label-header">{t("shopLabel")}</div>
                {shop && (
                  <div onClick={openExpandedMapView}>
                    {!showModifyAppointment && (
                      <span className="change_link-button">{t("schedule:changeLabel")}</span>
                    )}
                  </div>
                )}
              </div>
              {shop ? (
                <div className="shop-details-section">
                  <div className="shop-name-section">
                    <div className="shop-logo-section">
                      <div className="shop_name">{shop.name}</div>
                    </div>
                  </div>
                  <div className="selected-shop-address">
                    {shop.address_line1}, {shop.city}, {shop.state} {shop.zip}
                  </div>
                </div>
              ) : (
                <div className="no-shop-selected-text">{t("noShopSelectedLbl")}</div>
              )}
            </div>
            <div className="cart-horizontal-divider"></div>
            {activeVehicle && (
              <div className="side-panel-services-active-vehicle-section">
                <div>
                  <div className="active-vehicle-label-header">{t("activeVehicleLabel")}</div>
                  <div className="active-vehicle-details">
                    <div>{fetchVehicleName(activeVehicle)}</div>
                  </div>
                </div>
                <Image
                  className="active-vehicle-image"
                  src={activeVehicle?.dashboard_url || placeholderCarImg}
                />
              </div>
            )}
            <div className="cart-horizontal-divider"></div>
            <div className="side-panel_services-header">
              <p className="secondary-font headings-label">{`${t(
                "servicesLabel"
              )} (${cartQuantity})`}</p>
              {(isCart || showModifyAppointment || (cart && !cart.is_tire_order)) && (
                <Link
                  to={{ pathname: navigationPaths.addServices(), state: 1 }}
                  onClick={() => closeSidebar()}
                  className="responsive-button"
                >
                  <Button basic>
                    <span className="secondary-font mobile-text">{t("addServicesLabel")}</span>
                    <ReactSVG src="images/add_icon_vector.svg" />
                    <span className="secondary-font text">{t("addMoreServicesLabel")}</span>
                  </Button>
                </Link>
              )}
            </div>
            {showValvolineServiceMessage() && (
              <div className="valvoline-benefits-banner">
                <ReactSVG src={RocketSvg} />
                <span>
                  Based on what other <span className="font-bold">Uber drivers</span> prefer, we've
                  pre-selected an oil change at Valvoline for its top-rated discount.
                </span>
              </div>
            )}
            {!shop && (
              <div className="side-panel-services-label">
                <Image src={InfoLogo} />
                <span>{t("pricesShownLabel")}</span>
              </div>
            )}
            {cart &&
              cart.order_services.map((os, index) => (
                <ServiceRow
                  index={index}
                  key={os.id}
                  os={os}
                  pe={os.price_estimate}
                  order={cart}
                  updateCart={updateCart}
                  user={user}
                  t={t}
                  isCart={isCart}
                  isMiniCart={isMiniCart}
                />
              ))}
            {isCart && (
              <MaintenanceScheduleServices
                vehicleTypeId={activeVehicle && activeVehicle.vehicle_type_id}
                isMiniCart={isMiniCart}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="side-panel_services-section side-panel_service_empty_cart">
          <NoAddedService closeSidebar={closeSidebar} />
          <MaintenanceScheduleServices
            vehicleTypeId={activeVehicle && activeVehicle.vehicle_type_id}
            isMiniCart={isMiniCart}
          />
        </div>
      )}
    </div>
  )
}

export default ServiceSection
